import { useGetCustomerNamesQuery } from "../api/Customers";

import type { UUID } from "../../../utils";

export function useCustomerNamesResponse(customerIds?: UUID | UUID[]) {
  const {
    data,
    refetch,
    isLoading: isCustomerNamesLoading,
    isError: isCustomerNamesError,
  } = useGetCustomerNamesQuery({ customerIds }, { skip: !customerIds?.length });

  return {
    data,
    refetch,
    isCustomerNamesLoading,
    isCustomerNamesError,
  };
}
